export default __webpack_public_path__ + "static/media/close-icon-mobile-white.7de7f3b1.svg";